import { Link } from 'react-router-dom';
import { Screen } from '../components/AppShell';
import { Icon, Skeleton, EmptyState, StatusText, StatusPill } from '../components/ui';
import { api, type Customer } from '../lib/api';
import { useLoad } from '../lib/hooks';
import { reminderStatus } from '../../../shared/schedule';
import './screens.css';

export default function Customers() {
  const { data, loading, error, reload } = useLoad<{ customers: Customer[] }>(() => api.get('/customers'));

  return (
    <Screen
      onRefresh={reload}
      title="Customers"
      back="/more"
      action={
        <Link to="/customers/new" className="btn btn-primary btn-sm">
          <Icon name="plus" size={17} />
          Add
        </Link>
      }
    >
      <div className="stack-4">
        {error ? <div className="notice notice-danger">{error}</div> : null}
        {loading && !data ? <Skeleton rows={5} /> : null}

        {data && data.customers.length === 0 ? (
          <EmptyState
            title="No customers yet"
            body="Add the operators whose vehicles you inspect."
            action={
              <Link to="/customers/new" className="btn btn-primary">
                Add a customer
              </Link>
            }
          />
        ) : null}

        {data && data.customers.length > 0 && (
          <div className="panel divide">
            {data.customers.map((customer) => {
              const licence = reminderStatus(customer.o_licence_expiry, 'annual');
              return (
                <Link key={customer.id} to={`/customers/${customer.id}`} className="listrow">
                  <div className="grow">
                    <div className="listrow-title truncate">{customer.name}</div>
                    <div className="listrow-sub truncate">
                      {customer.asset_count ?? 0} vehicle{customer.asset_count === 1 ? '' : 's'}
                      {customer.o_licence_no ? (
                        <>
                          <span className="dot" />
                          <span className="mono">{customer.o_licence_no}</span>
                        </>
                      ) : null}
                      {customer.contact_name ? (
                        <>
                          <span className="dot" />
                          {customer.contact_name}
                        </>
                      ) : null}
                    </div>
                  </div>
                  {licence.state === 'overdue' ? (
                    <StatusPill state="overdue" size="sm">
                      O-Licence {licence.label.toLowerCase()}
                    </StatusPill>
                  ) : licence.state === 'due' ? (
                    <StatusText state="due">O-Licence {licence.label.toLowerCase()}</StatusText>
                  ) : null}
                </Link>
              );
            })}
          </div>
        )}
      </div>
    </Screen>
  );
}
